import { type FC, type ReactNode } from "react";

export const PanelTitle: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="font-semibold text-slate-800">{children}</div>
);
